var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"compatibles"},[_c('div',{staticClass:"container"},[_c('span',[_vm._v("Compatibility with your tools from:")]),_vm._l((_vm.tools),function(logo,i){return _c('h3',{key:i},[_vm._v(_vm._s(logo))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }